import { render, staticRenderFns } from "./baseCom.vue?vue&type=template&id=3d86d56d&scoped=true"
import script from "./baseCom.vue?vue&type=script&lang=js"
export * from "./baseCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=3d86d56d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86d56d",
  null
  
)

export default component.exports